import { Toast } from "antd-mobile";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Navigate, useSearchParams } from "react-router-dom";
import PsContext from "../../context";
import {
  _ForgotPasswordOtpRequest,
  _UpdateNewPassword,
} from "../../models/login";
import { formToObject } from "../../utils";
import Header from "../header";

const V2OtpResetPassword = (props) => {
  const context = useContext(PsContext);
  const [searchParams] = useSearchParams();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [userApi, setUserApi] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const verifyOtpForm = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    const formObject = formToObject(form);
    let otp = searchParams.get("otp");
    otp = context.decode(otp);

    try {
      if (formObject.otp != otp.otp) {
        Toast.show({
          content: "Invalid Otp",
        });
        return;
      }
      setIsOtpVerified(true);
    } catch (er) {}
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    const formObject = formToObject(form);

    if (formObject.password !== formObject.confirm_password) {
      Toast.show({
        content: "Password & Confirm Passwrd does not match",
      });
      return;
    }
    context.setLoader(true);
    _UpdateNewPassword(formObject).then((res) => {
      if (res.status == "1") {
        Toast.show({
          content: res.message || "Password Updated",
        });
        setUserApi(res.data);
      } else {
        Toast.show({
          content: res.message || "Unknown Error",
        });
      }
      context.setLoader(false);
    });
  };

  if (userApi) {
    return <Navigate to={`/staff/login`} />;
  }

  return (
    <>
      <Header title="Reset Password" rightActions={[]} backAction={[]} />
      <div className="py-5 "></div>
      <div className="container py-2">
        {!isOtpVerified && (
          <div data-aos="zoom-in">
            <div>
              <Form
                action=""
                method="post"
                noValidate
                validated={validated}
                onSubmit={verifyOtpForm}
              >
                <Row className="py-3 mb-2">
                  <Col md={12} className="text-center">
                    <h5 className="text-danger fw-bold">Enter your OTP</h5>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Control
                      type="number"
                      className="fw-bold"
                      name="otp"
                      autoFocus={true}
                      autoComplete="off"
                      placeholder="OTP"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md={12}>
                    <Button
                      type="submit"
                      className="w-100"
                      variant="danger"
                      size="lg"
                    >
                      Verify Orp
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        )}
        {isOtpVerified && (
          <div data-aos="zoom-in">
            <div>
              <Form
                action=""
                method="post"
                noValidate
                validated={validated}
                onSubmit={handleFormSubmit}
              >
                <input
                  type="hidden"
                  name="user"
                  value={searchParams.get("k")}
                />
                <Row className="py-3 mb-2">
                  <Col md={12} className="text-center">
                    <h5 className="text-danger fw-bold">Set New Password</h5>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Control
                      type={showPass ? "text" : "password"}
                      className="fw-bold"
                      name="password"
                      autoFocus={true}
                      autoComplete="off"
                      placeholder="Password"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={12}>
                    <Form.Control
                      type={showPass ? "text" : "password"}
                      className="fw-bold"
                      name="confirm_password"
                      autoComplete="off"
                      placeholder="Confirm Password"
                      required
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={12}>
                    <a onClick={(e) => setShowPass(!showPass)}>
                      {showPass ? "Hide Passwords" : "Show Passwords"}
                    </a>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={12}>
                    <Button
                      type="submit"
                      className="w-100"
                      variant="danger"
                      size="lg"
                    >
                      Set Password
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default V2OtpResetPassword;
